import { inject, injectable } from "@launchtray/tsyringe-async";
import { Bindable, NotifyProperty, nameof } from "../../../../../shared/bindable-data";
import { INetworkClient } from "../../../../networking/INetworkClient";
import { PersonalOfferReason } from "../../../../networking/data/responses/personaloffer/PersonalOfferReason";
import { BuyOffer } from "./BuyOffer";
import { IDiceRollsOfferModel } from "./IDiceRollsOfferModel";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";

@injectable()
export class DiceRollsOfferModel extends Bindable implements IDiceRollsOfferModel {
    public readonly diceRollsOffer: NotifyProperty<BuyOffer>;

    private readonly networkClient: INetworkClient;
    private readonly logger: ILogger;

    public constructor(
        @inject("INetworkClient") networkClient: INetworkClient,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        this.networkClient = networkClient;
        this.logger = logger;
        this.diceRollsOffer = new NotifyProperty<BuyOffer>(this, nameof("diceRollsOffer"), null);
    }

    public async getOfferDto(source: PersonalOfferReason): Promise<boolean> {
        try {
            const response = await this.networkClient.getPersonalOffer(source);
            if (response.offer == undefined) {
                return false;
            }
            this.diceRollsOffer.setValue(response.offer);
            return true;
        } catch (error: unknown) {
            this.logger.error(error);
        }
    }
}
